import { Box } from '@mui/material';

import { FANTASY } from '@/helpers/biwenger-helper';

import EquipoPlayerLineupAnaliticaMode from './EquipoPlayerLineupAnaliticaMode';
import EquipoPlayerLineupBiwengerMode from './EquipoPlayerLineupBiwengerMode';
import EquipoPlayerLineupFantasyMode from './EquipoPlayerLineupFantasyMode';
import EquipoPlayerLineupSimpleMode from './EquipoPlayerLineupSimpleMode';

const EquipoPlayerLineupMode = ({
    player,
    mode,
    top,
    subMode,
    banquillo,
    onClick,
    customSize,
    textColor,
}) => {
    return (
        <Box
            sx={{
                position: 'relative',
                top: top,
                width: banquillo ? '20%' : 'auto',
                display: 'flex',
                justifyContent: 'center',
            }}
        >
            {mode === FANTASY.FANTASY && (
                <EquipoPlayerLineupFantasyMode
                    player={player}
                    banquillo={banquillo}
                    onClick={onClick}
                    customSize={customSize}
                />
            )}
            {mode === FANTASY.BIWENGER && (
                <EquipoPlayerLineupBiwengerMode
                    player={player}
                    subMode={subMode}
                    banquillo={banquillo}
                    onClick={onClick}
                    customSize={customSize}
                />
            )}
            {(mode || mode === 0) && mode !== FANTASY.FANTASY && mode !== FANTASY.BIWENGER && (
                <EquipoPlayerLineupAnaliticaMode
                    player={player}
                    banquillo={banquillo}
                    onClick={onClick}
                    customSize={customSize}
                    textColor={textColor}
                />
            )}

            {!mode && mode !== 0 && (
                <EquipoPlayerLineupSimpleMode
                    player={player}
                    banquillo={banquillo}
                    onClick={onClick}
                    customSize={customSize}
                />
            )}
        </Box>
    );
};

export default EquipoPlayerLineupMode;
